import React, { ReactNode } from 'react'
import * as styles from './Testimonial.module.scss'
import SlideAndFade from '../SlideAndFade'

interface TestimonialProps {
  name: string
  quote: ReactNode
  position: ReactNode
  pic: ReactNode
}
const Testimonial: React.FC<TestimonialProps> = ({ name, quote, pic, position }: TestimonialProps) => {
  return (
    <SlideAndFade
      style={{ opacity: 0.01 }}
      direction='up'
      duration={20 / 24 * 1000}
      delay={10 / 24 * 1000}
    >
      <div className={styles.container}>
        <div className={styles.frame}>
          <div className={styles.pic}>
            {pic}
          </div>
          <div className={styles.quote}>
            {quote}
          </div>
          <div className={styles.name}>
            {name}
          </div>
          <div className={styles.position}>
            {position}
          </div>
        </div>
      </div>
    </SlideAndFade>
  )
}

export default Testimonial
